import React from 'react';
import PropTypes from 'prop-types';
import { formatPercent } from '../../../fund/fund-components/shared-utils';
import {
  Fact,
  Title,
  Value,
} from './styles';

export default function PercentageDataFact({
  label,
  value,
  nullReplacement,
  perAnnual,
  date,
  clazz,
}) {
  return (
    <Fact className={clazz}>
      <Title>{label}</Title>
      <Value>
        {value === '' ? nullReplacement : formatPercent(value)}
        {value !== '' && perAnnual && <span className="small">p.a.</span>}
        {value !== '' && !!date && <div className="date">{date}</div>}
      </Value>
    </Fact>
  );
}

PercentageDataFact.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  nullReplacement: PropTypes.string.isRequired,
  perAnnual: PropTypes.bool,
  date: PropTypes.string,
  clazz: PropTypes.string,
};

PercentageDataFact.defaultProps = {
  value: null,
  perAnnual: false,
  date: null,
  clazz: null,
};
